import React, { useState } from "react";
import { formatINR, formatUSD } from "./revenueSummaryUtils";

const FINANCE_TILE_CLASS = {
	"INR — Received (all-time)": {
		card: "rs-finance-tile rs-finance-tile--inr-received",
		label: "rs-finance-tile-label rs-finance-tile-label--inr-received",
		value: "rs-finance-tile-value rs-finance-tile-value--inr-received",
	},
	"INR — Outstanding (all-time)": {
		card: "rs-finance-tile rs-finance-tile--inr-outstanding",
		label: "rs-finance-tile-label rs-finance-tile-label--inr-outstanding",
		value: "rs-finance-tile-value rs-finance-tile-value--inr-outstanding",
	},
	"USD — Received (all-time)": {
		card: "rs-finance-tile rs-finance-tile--usd-received",
		label: "rs-finance-tile-label rs-finance-tile-label--usd-received",
		value: "rs-finance-tile-value rs-finance-tile-value--usd-received",
	},
	"USD — Outstanding (all-time)": {
		card: "rs-finance-tile rs-finance-tile--usd-outstanding",
		label: "rs-finance-tile-label rs-finance-tile-label--usd-outstanding",
		value: "rs-finance-tile-value rs-finance-tile-value--usd-outstanding",
	},
};

const FinanceOperationsOutstanding = ({ summary }) => {
	const [expanded, setExpanded] = useState(false);

	if (!summary) return null;

	const inr = summary.inr || {};
	const usd = summary.usd || {};

	const tiles = [
		{ label: "INR — Received (all-time)", value: formatINR(inr.receivedINR) },
		{ label: "INR — Outstanding (all-time)", value: formatINR(inr.outstandingINR) },
		{ label: "USD — Received (all-time)", value: formatUSD(usd.receivedUSD) },
		{ label: "USD — Outstanding (all-time)", value: formatUSD(usd.outstandingUSD) },
	];

	return (
		<div className="admin-form-container-v4 rs-finance-ops">
			<button type="button" onClick={() => setExpanded((v) => !v)} className="rs-finance-ops-toggle">
				<div>
					<div className="rs-finance-ops-title">Finance Operations — All-Time Outstanding</div>
					<div className="rs-finance-ops-desc">
						Cumulative pending across all months, not just this month
					</div>
				</div>
				<span className="rs-finance-ops-icon">{expanded ? "▲ Hide" : "▼ Show"}</span>
			</button>
			{expanded && (
				<div className="rs-finance-ops-body">
					<div className="rs-finance-ops-grid">
						{tiles.map((tile) => {
							const cls = FINANCE_TILE_CLASS[tile.label];
							return (
								<div key={tile.label} className={cls.card}>
									<div className={cls.label}>{tile.label}</div>
									<div className={cls.value}>{tile.value}</div>
								</div>
							);
						})}
					</div>
				</div>
			)}
		</div>
	);
};

export default FinanceOperationsOutstanding;
